export const YelpIcon = (props: React.ComponentPropsWithoutRef<"svg">) => {
	return (
		<svg viewBox="0 0 24 31" {...props}>
			<use href="/images/icons.svg#vlw-yelp" />
		</svg>
	)
}
